import { createContext, Dispatch, ReactNode } from "react";

export type ProcoreMenuItem = {
    id: string;
    label: ReactNode;
    onClick: () => void;
    /** Disabled while the viewer is offline. The item stays visible. */
    requiresNetwork?: boolean;
};

export function isProcoreMenuItemDisabled(item: Pick<ProcoreMenuItem, "requiresNetwork">, isOnline: boolean): boolean {
    return item.requiresNetwork === true && !isOnline;
}

export const initialState: ProcoreMenuItem[] = [];

export type State = typeof initialState;

enum ActionTypes {
    Add,
    RemoveItems,
}

function add(item: ProcoreMenuItem) {
    return {
        type: ActionTypes.Add as const,
        item,
    };
}

function removeItems(ids: string[]) {
    return {
        type: ActionTypes.RemoveItems as const,
        ids,
    };
}

export const actions = {
    add,
    removeItems,
};

type Actions = ReturnType<(typeof actions)[keyof typeof actions]>;
export type DispatchProcoreStampMenuItems = Dispatch<Actions>;

export const StateContext = createContext<State | undefined>(undefined);
export const DispatchContext = createContext<DispatchProcoreStampMenuItems>(
    undefined as unknown as DispatchProcoreStampMenuItems,
);

export function reducer(state: State, action: Actions): State {
    switch (action.type) {
        case ActionTypes.Add: {
            return [...state, action.item];
        }
        case ActionTypes.RemoveItems: {
            return state.filter((item) => !action.ids.includes(item.id));
        }
        default: {
            throw new Error(`Unhandled action type`);
        }
    }
}
